"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidStorageTimestamp = void 0;
var _constants = require("../constants");
/**
 * Checks a timestamp flag stored with the data in storage for not being older
 * than the specified time amount. If true, the stored data can be re-used.
 * If false, the data is stale and has to be reloaded.
 */
const isValidStorageTimestamp = timestamp => Date.now() - timestamp <= _constants.DATA_CACHE_TIMEOUT;
exports.isValidStorageTimestamp = isValidStorageTimestamp;
